export default __webpack_public_path__ + "static/media/video-play-icon.74cf3016.svg";